import { useEffect } from 'react'
import styled from '@emotion/styled'
import {
  fetchCustomerLoyalty,
  selectCustomerLoyalty,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { Loading, LoyaltyProgram, PageContent, PageError } from 'components'

const LoyaltyProgamsView = styled.div`
  & > div + div {
    margin: 3rem auto 0;
  }
`

const LoyaltyPrograms = () => {
  const dispatch = useAppDispatch()
  const { entities, loading, error } = useAppSelector(selectCustomerLoyalty)
  const isLoading = loading === 'pending'

  useEffect(() => {
    dispatch(fetchCustomerLoyalty())
  }, [dispatch])

  return (
    <PageContent>
      {error ? (
        <PageError error={error} />
      ) : entities.length ? (
        <LoyaltyProgamsView>
          {entities.map((program) => {
            return (
              <LoyaltyProgram
                key={program.name}
                program={program}
                isLoading={isLoading}
              />
            )
          })}
        </LoyaltyProgamsView>
      ) : isLoading ? (
        <Loading text="Retrieving your loyalty status..." />
      ) : (
        <p>Looks like you don't have any reward programs yet.</p>
      )}
    </PageContent>
  )
}

export default LoyaltyPrograms
